import { useState } from "react";
import { useLocation, Link } from "wouter";
import { Home, BarChart2, BookOpen, User, Users } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAppContext } from "@/context/AppContext";
import { useTheme } from "@/components/ui/theme-provider";
import { translations, type Locale } from '@/i18n/translations';

export function BottomNav() {
  const [location] = useLocation();
  const { panicMode, language, t } = useAppContext();
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  if (panicMode) return null;

  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 supports-[backdrop-filter]:backdrop-blur-xl bg-white/80 dark:bg-white/10 border-t border-white/40 dark:border-white/10 shadow-[0_-12px_30px_-20px_rgba(0,0,0,0.25)] flex justify-around pb-safe">
      <NavItem 
        to="/" 
        icon={<Home className="h-6 w-6" />} 
        label={t('bottomNav.home', 'Home')}
        isActive={location === "/"} 
      />
      <NavItem 
        to="/community" 
        icon={<Users className="h-6 w-6" />} 
        label={t('bottomNav.community', 'Community')}
        isActive={location === "/community"} 
      />
      <NavItem 
        to="/track" 
        icon={<BarChart2 className="h-6 w-6" />} 
        label={t('bottomNav.track', 'Track')}
        isActive={location === "/track"} 
      />
      <NavItem 
        to="/resources" 
        icon={<BookOpen className="h-6 w-6" />} 
        label={t('bottomNav.resources', 'Resources')}
        isActive={location === "/resources"} 
      />

      <NavItem 
        to="/profile" 
        icon={<User className="h-6 w-6" />} 
        label={t('bottomNav.profile', 'Profile')}
        isActive={location === "/profile"} 
      />
    </nav>
  );
}

interface NavItemProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
}

function NavItem({ to, icon, label, isActive }: NavItemProps) {
  //const { theme } = useTheme();
  //const isDarkMode = false; //theme === "dark";
  return (
    <Link
      href={to}
      className={cn(
        "flex flex-col items-center justify-center py-2.5 px-1 flex-1 min-w-0",
        isActive ? "text-primary" : "text-gray-900"
      )}
    >
      <div
        className={cn(
          "grid place-items-center rounded-2xl transition-all shrink-0",
          isActive ? "bg-primary/15 text-primary" : "bg-transparent"
        )}
        style={{ width: 44, height: 28 }}
      >
        {icon}
      </div>
      <span className={cn("text-[12px] mt-1 text-center leading-tight", isActive ? "font-semibold" : "text-gray-900"
      )}>{label}</span>
    </Link>
  );
}

export default BottomNav;
